<template>
  <div id="NoticeDetail" :style="{width:width}">
    <!-- 头部导航部分 -->
    <HomeHeader />
    <div style="height:70px;"></div>
    <!-- 内容 -->
    <div class="list_body">
      <div class="item_title">
        {{content_title}}
      </div>
      <div class="time">
        {{defaultData.updateTime}}
        <span>发布</span>
        <i class="el-icon-view" style="color: #333;font-size: 14px;margin-left: 30px;margin-right: 4px"></i>
        <span style="line-height: 1">{{!defaultData.priorityScore ? '1' : defaultData.priorityScore}}</span>
      </div>
      <div class="item_content" v-html="defaultData.content"></div>
    </div>
    <HomeFooter style="margin-top: 78px;"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { getInformationItem } from '@/api/modules/Information'
export default {
  name: 'NoticeDetail',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      content_title: ''
    }
  },
  created() {
    this.getList(this.$route.query.id)
  },
  methods: {
    async getList(id) {
      const obj = {
        contentId: id
      }
      const res = await getInformationItem(obj)
      if (res.code === 0) {
        this.content_title = res.data.title
        this.defaultData = res.data
        this.defaultData.updateTime = this.timestampToTime(this.defaultData.updateTime)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        return
      }
    },
    timestampToTime(timestamp) {
      const date = new Date(timestamp)
      var Y = date.getFullYear() + '年'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
      var D = date.getDate() + '日'
      // var h = date.getHours() + ':'
      // var m = date.getMinutes() + ':'
      // var s = date.getSeconds()
      return Y + M + D
    }
  }
}
</script>

<style lang="less" scoped>
// top
.notice-top{
  width:1340px;
  margin:0 auto;
  background: #FFFFFF;
  border: 1px solid rgba(6, 15, 26, 0.07);
  border-radius: 6px;
  height: 64px;
  padding: 21px 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-top:60px;
  .topbar-back{
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    color: #10141A;
    cursor: pointer;
  }
  .topbar-back-icon{
    display: block;
    width: 12px;
    height: 20px;
    background-size: 12px 20px;
    background-image: url(../../../assets/img/home/leftArrow.png);
    margin-right: 6px;
    background-size: 100% 100%;
    width: 20px;
  }
  .topbar-title{
    border-left: 1px solid rgba(8, 16, 26, 0.25);
    padding-left: 24px;
    margin-left: 24px;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    color: #10141A;
  }
}
// 内容
.list_body{
  width:1340px;
  margin:0 auto;
  border: 1px solid rgba(6, 15, 26, 0.07);
  border-radius: 6px;
  margin-top: 48px;
  overflow: hidden;
  background: #fff;
  padding:32px 24px;
  min-height: 54vh;
  .item_title{
    font-weight: 500;
    font-size: 28px;
    line-height: 34px;
    color: #10141A;
    margin: 0 0 24px 0;
    padding: 0;
  }
  .time{
    font-size: 14px;
    color:#333;
  }
  .item_content{
    margin-top: 32px;
    padding-bottom: 30px;
    color: #333;
    font-size: 16px;
    line-height: 22px;
  }
  .item_bottom{
    margin-top:16px;
    color: rgba(11, 18, 26, 0.6);
  }
}
.noData{
  text-align: center;
  padding: 70px 0;
  line-height: 50px;
  font-size: 24px;
  color:#DDD;
}
</style>
